import React from "react";

import { faEllipsis } from "@fortawesome/pro-regular-svg-icons";

import { DropDownMenu, Icon } from "@performyard/py-components";

import { AIButton } from "../../../../../../../components/AIModules/AIButton/AIButton";
import { AIPromotionalButton } from "../../../../../../../components/AIModules/AIPromotionalButton/AIPromotionalButton";

import { useDownloadSurveyResultsCSV } from "../../../../../../../api/hooks";
import { useAiPromotion } from "../../../../../../../hooks/useAiPromotion";
import { useSurvey } from "../../../hooks/useSurvey";
import { useSurveyResultsKPIs } from "../hooks/useSurveyResultsKPIs";

export const SubsectionUtilGroup = ({
	surveyId,
	showSummaryCSV = false,
	search,
	sorts,
}: {
	surveyId: string;
	showSummaryCSV?: boolean;
	search?: { field: string; operator: "eq" | "re"; value: string };
	sorts?: Record<string, number>;
}) => {
	const { mutate: downloadCSV } = useDownloadSurveyResultsCSV(surveyId);
	const { survey } = useSurvey({ surveyId });
	const { participantSubmissions } = useSurveyResultsKPIs({ surveyId });
	const { isAiPromotion, promotionId, userEmail } = useAiPromotion();

	return (
		<div className="flex items-center justify-end gap-2">
			{["active", "closed"].includes(survey?.status ?? "") && participantSubmissions.value > 0 && (
				<AIButton buttonSize="medium" moduleType="surveyInsights" surveyId={surveyId} />
			)}
			{isAiPromotion && (
				<AIPromotionalButton
					label="AI Insights"
					promotionId={promotionId}
					userEmail={userEmail}
					buttonSize="medium"
				/>
			)}
			<DropDownMenu
				placement="bottom-end"
				bordered
				options={[
					{
						key: "participant-csv-download",
						label: "Download Participant CSV",
						onClick: () => {
							downloadCSV({});
						},
					},
					...(showSummaryCSV
						? [
								{
									key: "summary-csv-download",
									label: "Download Summary CSV",
									onClick: () => {
										downloadCSV({
											exportType: "summary",
											...(search ? { search } : {}),
											...(sorts ? { sorts } : {}),
										});
									},
								},
							]
						: []),
				]}
				className="flex items-center justify-center"
			>
				<Icon icon={faEllipsis} size={16} color="neutral-5" />
			</DropDownMenu>
		</div>
	);
};

export default SubsectionUtilGroup;
